import errorManager from '@/rollbar.js';

const handleEditGestioneOre = () => {
  const checkboxGestioneOreEdit = document.querySelectorAll('[id^="edit_gestione_ore-"]');
  checkboxGestioneOreEdit.forEach((checkbox) => {
    checkbox.onchange = (event) => {
      const currentCheckbox = event.currentTarget;
      if (currentCheckbox.checked === true) {
        const id = currentCheckbox.id.split('-')[1];
        const oldShmFrom = document.querySelector(`#old-shm-from-${id}`);
        const oldShmTo = document.querySelector(`#old-shm-to-${id}`);
        oldShmFrom.removeAttribute('disabled');
        oldShmTo.removeAttribute('disabled');
      } else {
        const id = currentCheckbox.id.split('-')[1];
        const oldShmFrom = document.querySelector(`#old-shm-from-${id}`);
        const oldShmTo = document.querySelector(`#old-shm-to-${id}`);
        oldShmFrom.setAttribute('disabled', 'disabled');
        oldShmTo.setAttribute('disabled', 'disabled');
      }
    };
  });
};

const handleRadioButtons = (newGestioneOreSelector, UpdateOldGestioneOreSelector) => {
  const newGestioneOre = document.querySelector(newGestioneOreSelector);
  const oldGestioneOre = document.querySelector(UpdateOldGestioneOreSelector);

  if (newGestioneOre) {
    newGestioneOre.onchange = () => {
      oldGestioneOre.checked = false;
      alert('Verrà creata una nuova gestione ore');
    };
  }

  if (oldGestioneOre) {
    oldGestioneOre.onchange = () => {
      newGestioneOre.checked = false;
      alert('Verrà aggiornata la gestione ore esistente');
    };
  }
};
const init = (newGestioneOreSelector, UpdateOldGestioneOreSelector) => {
  try {
    handleRadioButtons(newGestioneOreSelector, UpdateOldGestioneOreSelector);
    handleEditGestioneOre();
  } catch (e) {
    errorManager(e);
  }
};

window.HandleHourManagement = {
  init: init,
};
